var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayeredWave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 100,
    viewBox: "0 0 1000 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3561_3256)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1000 0C500 0 500 36 0 36V100H1000V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1000 0C500 0 500 66 0 66V100H1000V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000 0C500 0 500 96 0 96V100H1000V0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3561_3256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 100,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 100)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayeredWave);
export default __webpack_public_path__ + "static/media/layered-wave.9e452a18a401a6e096463e306b2bf874.svg";
export { ForwardRef as ReactComponent };